// DEPLOY
// https://jasonwatmore.com/post/2020/01/11/vuejs-aspnet-core-on-azure-with-sql-server-how-to-deploy-a-full-stack-app-to-microsoft-azure
// Komentar
// PrimeVUE
import 'primevue/resources/themes/saga-blue/theme.css'
import 'primevue/resources/primevue.min.css'
import 'primeflex/primeflex.css'
import 'primeicons/primeicons.css'


import './assets/layout/layout.scss'
import './assets/layout/flags/flags.css'

import { createApp } from 'vue'
// import { createStore } from 'vuex'
import store from './store'
import App from './App.vue'
import router from './router'

import PrimeVue from 'primevue/config'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import InputNumber from 'primevue/inputnumber';
import Textarea from 'primevue/textarea';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Menubar from 'primevue/menubar';
import Dialog from 'primevue/dialog';
import ConfirmationService from 'primevue/confirmationservice';
import ToastService from 'primevue/toastservice';
import Toast from 'primevue/toast';
import ConfirmDialog from 'primevue/confirmdialog';
import MultiSelect from 'primevue/multiselect';
import Dropdown from 'primevue/dropdown';
import Divider from 'primevue/divider';
import Checkbox from 'primevue/checkbox';
import Password from 'primevue/password';

//import VueAuthHref from 'vue-auth-href';

// Create a new store instance.
/*
const store = createStore({
    state () {
      return {
        count: 0
      }
    },
    mutations: {
      increment (state) {
        state.count++
      }
    }
  })
  */
  //// console.log('javljam se iz index.js iz roota');
  //require("dotenv").config();

const app = createApp(App)
// console.log('CONFIG!!!')
// console.log(app.config)
debugger;
app.use(router)

app.use(store)

app.use(PrimeVue)
app.use(ConfirmationService);
app.use(ToastService);
// https://github.com/nachodd/vue-auth-href
//app.use(VueAuthHref);
//app.use(VueAuthHref, { token: () => store.getters.getToken });

app.component('Menubar', Menubar)
app.component('InputText', InputText)
app.component('InputNumber', InputNumber)
app.component('Button', Button)
app.component('DataTable', DataTable)
app.component('Column', Column)
app.component('Dialog', Dialog)
app.component('ConfirmDialog', ConfirmDialog)
app.component('MultiSelect', MultiSelect)
app.component('Divider', Divider)
app.component('Textarea', Textarea)
app.component('Checkbox', Checkbox)
app.component('Dropdown', Dropdown)
app.component('Toast', Toast)
app.component('Password', Password)


//MultiSelect

app.mount('#app')

